import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { EventFormData, TicketData, VenueData, TicketGroupData } from "../../Events/CreateQickEventV2/types"
import { getAllTicketBySlug, getAllTicketBySlugV2, getAllVenueBySlug, updateTicket, getAllEvents, getEventById } from "../../../api";
import { getAllTicketGroupBySlug } from "../../../api";
import { createTicket, deleteTicket } from "../../../api";
import NormalTable from "../../../components/common/Tables/NormalTable";
import * as Yup from "yup";
import { useFormik } from "formik";
import { PulseLoader } from 'react-spinners';
import { toast } from "react-toastify";
import { ToastContainer } from 'react-toastify';
import { encodeNumber } from "../../../utils/encryption";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback,
} from "reactstrap";
import { handleError } from "../../../utils/errorHandler";
import moment from "moment";
import CommonSelect from "../../../components/common/Select/CommonSelect";
import { current } from "@reduxjs/toolkit";
import FormattedDate from "../../../components/common/DateFormat/FormattedDate";
import ListCard from "../../../components/common/ListCard/ListCard";
import NewTicketModal from "../../Events/CreateQickEventV2/Components/NewTicketModal"
import TicketGroupModal from "../../Events/CreateQickEventV2/Components/TicketGroupModal";
import { useNightMode } from "../../../contexts/NightModeContext";
import Background from "../../Login/Background";
import PageHeader from "../../../components/common/PageHeader/PageHeader";
import { Search, GripVertical, ChevronUp, ChevronDown } from "lucide-react";
import ConfirmationDialog from "../../../components/common/ConfirmationDialog/ConfirmationDialog";

const Tickets = () => {
  const { isNightMode } = useNightMode();
  const { slug, eventId } = useParams();
  const [ticket, setTicketList] = useState<any>([]);
  const [search, setSearch] = useState("");
  const [modal, setModal] = useState(false);
  const [showGroupTicketField, setShowGroupTicketField] = useState(false);
  const toggle = () => setModal(!modal);
  const [hasGroupTickets, setHasGroupTickets] = useState(false);
  const [groupTicketList, setGroupTicketList] = useState<any[]>([]);
  const [eventVenuesForAdd, setEventVenuesForAdd] = useState<any[]>([]);
  const [showVenueField, setShowVenueField] = useState(false);
  const [eventVenues, setEventVenues] = useState<any[]>([]);
  const [selectedVenueForAdd, setSelectedVenueForAdd] = useState<any>("0");
  const [editModal, setEditModal] = useState(false);
  const [editData, setEditData] = useState({ id: "", ticketType: "", ticketStatus: "", description: "", ticketOrder: "", maxCount: "", totalTicketsSold: 0, price: "", isGroupTicket: false, groupTicketCount: "" });
  const [selectedGroupSorting, setSelectedGroupSorting] = useState("0");
  const [filteredTickets, setFilteredTickets] = useState<any>([]);
  const [hasVenue, setHasVenue] = useState(false);
  const toggleEditModal = () => setEditModal(!editModal);
  // State for modal management
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isTicketGroupModalOpen, setIsTicketGroupModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [ticketKind, setTicketKind] = useState<'single' | 'group'>('single');
    const [editingTicketGroup, setEditingTicketGroup] = useState<TicketGroupData | undefined>(undefined);
    const [learnMoreModal, setLearnMoreModal] = useState(false);
    const [deleteConfirm, setDeleteConfirm] = useState<{ isOpen: boolean; ticket: any | null }>({ isOpen: false, ticket: null });
    const [learnMoreModalField, setLearnMoreModalField] = useState('');
    const [isTicketFree, setIsTicketFree] = useState(false);
    // True once isTicketFree has been confirmed against the event identified by
    // the current slug/eventId. Saving is blocked while this is false so a ticket
    // can never be submitted using a free/paid status carried over from a
    // previously viewed event.
    const [isTicketFreeResolved, setIsTicketFreeResolved] = useState(false);
    const [tickets, setTickets] = useState<TicketData[]>([]);
    const [venues, setVenues] = useState<VenueData[]>([]);
    const [ticketGroups, setTicketGroups] = useState<TicketGroupData[]>([]);
    const [hasMultipleVenues, setHasMultipleVenues] = useState(false);
    const [hasMultipleTicketGroups, setHasMultipleTicketGroups] = useState(false);
    const [hasHiddenTickets, setHasHiddenTickets] = useState(false);
    const [draggedIndex, setDraggedIndex] = useState<number | null>(null);
    const [dragOverIndex, setDragOverIndex] = useState<number | null>(null);

    /** Persist a new ticket order list to state + API. */
    const persistTicketOrder = async (updatedTickets: any[]) => {
      const reordered = updatedTickets.map((t, idx) => ({
        ...t,
        ticketOrder: idx + 1,
      }));

      setFilteredTickets(reordered);
      setTicketList(reordered);

      try {
        await Promise.all(
          reordered.map((item) => {
            const tId = item.ticketTypeId || item.id;
            if (tId) {
              return updateTicket(tId, {
                ticketOrder: item.ticketOrder,
                ticketType: item.ticketType || item.name,
                ticketStatus: item.ticketStatus || "active",
                price: item.price,
              });
            }
            return Promise.resolve();
          })
        );
        toast.success("Ticket order updated successfully");
      } catch (err) {
        console.error("Failed to update ticket order", err);
        getTicketList();
      }
    };

    /** Touch-friendly reorder for mobile (HTML5 drag is unreliable on phones). */
    const moveTicket = async (fromIndex: number, direction: -1 | 1) => {
      const toIndex = fromIndex + direction;
      if (toIndex < 0 || toIndex >= filteredTickets.length) return;
      const updatedTickets = [...filteredTickets];
      const [item] = updatedTickets.splice(fromIndex, 1);
      updatedTickets.splice(toIndex, 0, item);
      await persistTicketOrder(updatedTickets);
    };

    const handleDashboardDragStart = (e: React.DragEvent<HTMLDivElement>, index: number) => {
      setDraggedIndex(index);
      e.dataTransfer.effectAllowed = 'move';
      e.dataTransfer.setData('text/plain', index.toString());
    };

    const handleDashboardDragOver = (e: React.DragEvent<HTMLDivElement>, index: number) => {
      e.preventDefault();
      e.dataTransfer.dropEffect = 'move';
      if (dragOverIndex !== index) {
        setDragOverIndex(index);
      }
    };

    const handleDashboardDrop = async (e: React.DragEvent<HTMLDivElement>, dropIndex: number) => {
      e.preventDefault();
      if (draggedIndex === null || draggedIndex === dropIndex) {
        setDraggedIndex(null);
        setDragOverIndex(null);
        return;
      }

      const updatedTickets = [...filteredTickets];
      const [draggedItem] = updatedTickets.splice(draggedIndex, 1);
      updatedTickets.splice(dropIndex, 0, draggedItem);

      setDraggedIndex(null);
      setDragOverIndex(null);
      await persistTicketOrder(updatedTickets);
    };
    const handleCopyLink = async () => {
      try {
        const eventData = localStorage.getItem("eventData");
        if (!eventData) {
          toast.error("Event data not found");
          return;
        }
        const parsed = JSON.parse(eventData);
        const eventId = parsed.eventId;
        console.log("Event ID:", eventId);
        const slugID = parsed.slugId;
        if (!eventId || !slugID) {
          toast.error("Invalid event details");
          return;
        }
        const encryptedId = encodeNumber(Number(eventId));
        console.log("Encrypted ID:", encryptedId);
        const link = `https://eventox.co/event/${slugID}?tt=true&ev=${encryptedId}`;
        await navigator.clipboard.writeText(link);
        toast.success("Hidden ticket link copied!");
      } catch (error) {
        toast.error("Failed to copy link");
      }
    };
    useEffect(() => {
      const hiddenExists = ticket.some((t: any) => t.ticketStatus === "hidden");
      setHasHiddenTickets(hiddenExists);
    }, [ticket]);

   const openModal = (type: 'single' | 'group') => {
    setTicketKind(type);
    setIsModalOpen(true);
  };
   const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const syncIsTicketFree = (event?: any) => {
    try {
      const data = event === undefined ? localStorage.getItem("eventData") : event;
      if (!data) {
        setIsTicketFree(false);
        return;
      }
      const parsed = typeof data === "string" ? JSON.parse(data) : data;
      setIsTicketFree(String(parsed.ticketType) === "free");
    } catch (err) {
      console.error("Error reading event free status:", err);
      setIsTicketFree(false);
    }
  };

  useEffect(() => {
    resolveIsTicketFreeForCurrentEvent();
    getTicketList();
    checkIfEventHasGroupTickets();
    getEventVenue();
  }, [slug, eventId]);

  /**
   * Make isTicketFree reflect the event identified by the current slug/eventId,
   * never whichever event happens to already be sitting in localStorage (e.g.
   * left over from the previously viewed event). Blocks saving until resolved.
   */
  const resolveIsTicketFreeForCurrentEvent = async () => {
    setIsTicketFreeResolved(false);
    try {
      await getResolvedSlug();
    } finally {
      setIsTicketFreeResolved(true);
    }
  };

  // const getEventVenue = async () => {
  //   try {
  //     setIsLoading(true);
  //     const slugId = await getResolvedSlug();
  //     if (!slugId) return;
  //     const resp = await getAllVenueBySlug(slugId);
  //     const venueArr = Array.isArray(resp) ? resp : [];
  //     const venueOptions = venueArr.map((item: any) => {
  //       return {
  //         id: String(item.venueId),
  //         value: String(item.venueId),
  //         label: item.venueName,
  //         name: item.venueName
  //       };
  //     });
  //     setEventVenuesForAdd(venueOptions);
  //     setVenues(venueOptions);
  //     if (venueOptions.length === 1) {
  //       validation.setFieldValue("venueId", venueOptions[0].value);
  //       setSelectedVenueForAdd((prev: any) => (prev && prev !== "0" ? prev : venueOptions[0].value));
  //     }
  //     setEventVenues(venueOptions);
  //   } catch (error) {
  //     console.error("Error fetching event venues:", error);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const getResolvedSlug = async (targetId?: string): Promise<string> => {
    const idToFind = targetId || eventId || slug;
    const eventData = localStorage.getItem("eventData");
    if (eventData) {
      try {
        const parsed = JSON.parse(eventData);
        if (
          parsed.slugId &&
          isNaN(Number(parsed.slugId)) &&
          !idToFind
        ) {
          syncIsTicketFree(parsed);
          return parsed.slugId;
        }
      } catch (e) {}
    }
    if (idToFind && isNaN(Number(idToFind))) {
      // idToFind is already a slug, but the cached eventData above didn't match
      // it, so it can't be trusted for free/paid status. Resolve the event that
      // actually owns this slug before returning.
      try {
        const res: any = await getAllEvents();
        const list = Array.isArray(res) ? res : res?.data || [];
        const found = list.find((e: any) => String(e.slugId) === String(idToFind));
        if (found) {
          localStorage.setItem("eventData", JSON.stringify(found));
          syncIsTicketFree(found);
        } else {
          setIsTicketFree(false);
        }
      } catch (err) {
        console.error("Error resolving event by slug:", err);
        setIsTicketFree(false);
      }
      return idToFind;
    }
    if (idToFind) {
      try {
        const eventDetails = await getEventById(idToFind);
        if (eventDetails && eventDetails.slugId) {
          localStorage.setItem("eventData", JSON.stringify(eventDetails));
          syncIsTicketFree(eventDetails);
          return eventDetails.slugId;
        }
      } catch (err) {
        console.error("Error fetching event by ID:", err);
      }
    }
    try {
      const res: any = await getAllEvents();
      const list = Array.isArray(res) ? res : res?.data || [];
      const found = list.find(
        (e: any) => String(e.eventId) === String(idToFind) || String(e.id) === String(idToFind)
      );
      if (found) {
        localStorage.setItem("eventData", JSON.stringify(found));
        syncIsTicketFree(found);
        if (found.slugId) return found.slugId;
      }
    } catch (err) {
      console.error("Error resolving slugId:", err);
    }
    return idToFind || "";
  };

  const getEventVenue = async () => {
    try {
      setIsLoading(true);
      const slugId = await getResolvedSlug();
      if (!slugId) return;
      const resp = await getAllVenueBySlug(slugId);
      const venueArr = Array.isArray(resp) ? resp : [];
      const venueOptions = venueArr.map((item: any) => {
        return {
          id: String(item.venueId),
          value: String(item.venueId),
          label: item.venueName,
          name: item.venueName
        };
      });
      setEventVenuesForAdd(venueOptions);
      setVenues(venueOptions);
      if (venueOptions.length === 1) {
        validation.setFieldValue("venueId", venueOptions[0].value);
        setSelectedVenueForAdd((prev: any) => (prev && prev !== "0" ? prev : venueOptions[0].value));
      }
      setEventVenues(venueOptions);
    } catch (error) {
      console.error("Error fetching event venues:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const checkIfEventHasGroupTickets = async () => {
    try {
      const eventSlug = await getResolvedSlug();
      if (eventSlug) {
        const groupTickets = await getAllTicketGroupBySlug(eventSlug);

        if (groupTickets && Array.isArray(groupTickets) && groupTickets.length > 0) {
          const groupOptions = groupTickets.map((group: any) => ({
            id: String(group.id),
            name: group.groupName || group.name || "",
            value: String(group.id),
            label: group.groupName || group.name || "",
            isSlotRequired: Boolean(group.isSlotRequired),
            isActive: Boolean(group.isActive ?? true)
          }));

          setGroupTicketList(groupOptions);
          setTicketGroups(groupOptions);

          if (groupOptions.length === 1) {
            validation.setFieldValue("groupingId", groupOptions[0].value);
            validation.setFieldValue("groupName", groupOptions[0].label);
          }
        }

        const eventData = localStorage.getItem("eventData");
        const parsed = eventData ? JSON.parse(eventData) : null;
        const eventVenues = parsed?.eventVenues;
        if (eventVenues && Array.isArray(eventVenues) && eventVenues.length > 0) {
          const venues = eventVenues.map((venue: any) => ({
            id: String(venue._id),
            name: venue.venueName,
            value: String(venue._id),
            label: venue.venueName
          }));
          setEventVenuesForAdd(venues);
        }
      }
    } catch (error) {
      console.error("Error checking group tickets:", error);
    }
  };

  const getTicketList = async () => {
    try {
      setIsLoading(true);
      const eventSlug = await getResolvedSlug();

      if (eventSlug) {
        const response = await getAllTicketBySlugV2(eventSlug);
        const sorted = (response || []).sort((a: any, b: any) => {
          const orderA = a.ticketOrder ?? Infinity;
          const orderB = b.ticketOrder ?? Infinity;
          return orderA - orderB;
        });
        setTicketList(sorted);
        checkIfEventHasGroupTickets();
      }
    } catch (error) {
      console.error("Error fetching ticket list:", error);
      setTicketList([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let result = [...ticket];

    if (selectedVenueForAdd && selectedVenueForAdd !== "0") {
      result = result.filter(
        (item: any) => String(item.venueId) === String(selectedVenueForAdd)
      );
    }

    if (selectedGroupSorting && selectedGroupSorting !== "0") {
      result = result.filter(
        (item: any) => String(item.groupingId) === String(selectedGroupSorting)
      );
    }

    if (search.trim()) {
      const q = search.toLowerCase().trim();
      result = result.filter((item: any) =>
        item.ticketType?.toLowerCase().includes(q)
      );
    }

    setFilteredTickets(result);
  }, [ticket, selectedVenueForAdd, selectedGroupSorting, search]);


  const columns = [
    {
      label: "Ticket Name", key: "ticketType", cellContent: (row: any) => {
        return (
        <div>
          <span className="">{row.ticketType}</span><br />
          <span className="">{row.description}</span><br/>
        </div>
      )
    }
    },
    // { label: "Grouping Name", key: "groupName" },
    { label: "Price", key: "price" },
    { label: "Max Count", key: "maxCount",cellContent: (row: any) => <span>{row.maxCount === null ? "Unlimited" : row.maxCount}</span>   },
    { label: "Current Count", key: "currentCount" },
    { label: "Is Group Ticket(Count)", key: "isGroupTicket", cellContent: (row: any) => <span>{row.isGroupTicket ? `Yes (${row.groupTicketCount})` : "No"}</span> },
    {
      label: "Status", key: "ticketStatus",
      cellContent: (row: any) => <span className={row.ticketStatus === "active" ? "text-success" : "text-danger"}>{row.ticketStatus.charAt(0).toUpperCase() + row.ticketStatus.slice(1)}</span>
    },
    { label: "Created", key: "createdAt",cellContent: (row: any) => (
      <FormattedDate dateString={row?.createdAt} />
    ) },
   {
  label: "",
  key: "actions",
  cellContent: (row:any) => ( 
    <span className="d-flex justify-content-center align-items-center gap-4 cursor-pointer">
      <span className="text-primary" onClick={() => handleEdit(row)} style={{ cursor: "pointer" }}>
        <i className=" fa-solid fa-pencil"></i>
      </span>
      <span className="text-danger" onClick={() => handleDelete(row)} style={{ cursor: "pointer" }}>
        <i className="fa-solid fa-trash-alt"></i>
      </span>
    </span>
  ),
},
  ];
  const handleSearch = (e: any) => {
    setSearch(e.target.value);
  };

  const handleEdit = (ticket: any) => {
    setEditData({
      id: ticket.ticketTypeId,
      ticketType: ticket.ticketType,
      ticketStatus: ticket.ticketStatus,
      description: ticket.description,
      ticketOrder: ticket.ticketOrder,
      maxCount: ticket.maxCount ?? null,
      totalTicketsSold: ticket.totalTicketsSold || 0,
      price: ticket.price,
      isGroupTicket: ticket.isGroupTicket || false,
      groupTicketCount: ticket.groupTicketCount ?? "",
    });
    setEditModal(true);
  };
  const handleDelete = (ticket: any) => {
    setDeleteConfirm({ isOpen: true, ticket });
  };

  const confirmDelete = async () => {
    if (!deleteConfirm.ticket) return;
    try {
      await deleteTicket(deleteConfirm.ticket.ticketTypeId);
      toast.success("Ticket deleted successfully");
      getTicketList();
    } catch (error: any) {
      const errorMsg = error.response?.data?.message || "Failed to delete ticket";
      toast.error(errorMsg);
    }
  };
  const editValidation = useFormik({
    enableReinitialize: true,
    initialValues: {
      ticketType: editData.ticketType || "",
      ticketStatus: editData.ticketStatus || "active",
      description: editData.description || "",
      ticketOrder:  editData.ticketOrder ||"",
      maxCount: editData.maxCount ?? "",
      totalTicketsSold: editData.totalTicketsSold,
      price: editData.price ?? "",
      isGroupTicket: editData.isGroupTicket || false,
      groupTicketCount: editData.groupTicketCount ?? "",
    },
    validationSchema: Yup.object({
      ticketType: Yup.string().required("Ticket name is required"),
      ticketStatus: Yup.string().required("Status is required"),
      price: isTicketFree
        ? Yup.number()
            .transform((value, original) => (original === "" || original == null ? null : value))
            .nullable()
            .optional()
        : Yup.number().required("Ticket amount is required").typeError("Ticket amount must be a number"),
      ticketOrder: Yup.number()
        .nullable()
        .transform((value, original) => (original === "" || original == null ? null : value))
        .typeError("Ticket order must be a number"),
      maxCount: Yup.number()
        .nullable()
        .transform((value, original) => (original === "" ? null : value))
        .min(
          Yup.ref("totalTicketsSold"),
          "Max Count cannot be less than tickets already sold"
        )
        .typeError("Max Count must be a number"),
      groupTicketCount: Yup.number().when("isGroupTicket", {
        is: true,
        then: () =>
          Yup.number()
            .required("Group Ticket Count Required")
            .min(2, "Group capacity must be at least 2 attendees"),
      }),
    }),
   onSubmit: async (values) => {
  try {
    if (!isTicketFreeResolved) {
      toast.error("Still confirming this event's pricing type, please try again in a moment.");
      return;
    }
    setIsLoading(true);
    if (editData?.id) {
      const safeNum = (v: any) =>
        v === "" || v === null || v === undefined || isNaN(Number(v)) ? null : Number(v);
      const updatePayload: any = {
        ticketType: values.ticketType,
        ticketStatus: values.ticketStatus,
        description: values.description,
        ticketOrder: safeNum(values.ticketOrder),
        price: isTicketFree ? 0 : Number(values.price),
        maxCount: safeNum(values.maxCount),
        isGroupTicket: Boolean(values.isGroupTicket),
      };
      if (values.isGroupTicket) {
        updatePayload.groupTicketCount = safeNum(
          values.groupTicketCount ?? editData.groupTicketCount
        );
      }
      await updateTicket(editData.id, updatePayload);
      toast.success("Ticket updated successfully");
      await checkIfEventHasGroupTickets(); 
      await getEventVenue();               
      await getTicketList();
      toggleEditModal();
    }
  } catch (error: any) {
    const responseData = error?.response?.data;
    const errorMessage = typeof responseData === "string"
      ? responseData
      : responseData?.message || responseData?.error || "Failed to update ticket";
    toast.error(errorMessage);
  } finally {
    setIsLoading(false);
  }
}
  });
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      ticketType: "",
      price: "",
      maxCount: 0,
      currentCount: 0,
      groupTicketPrice: 0,
      eventSlug: slug,
      ticketOrder: "null",
      ticketStatus: "active",
      groupTicketCount: "",
      groupingId: "",
      isGroupTicket: "",
      venueId: "",
      description: "",
    },
    validationSchema: Yup.object({
      ticketType: Yup.string().required("Ticket Name Required"),
      price: Yup.number()
        .required("Price Required"),
      // ticketOrder: Yup.number()
      //   .required("Ticket Order Required")
      //   .positive("Order must be positive"),
      groupTicketCount: Yup.number().when("isGroupTicket", {
        is: true,
        then: () =>
          Yup.number()
            .required("Group Ticket Count Required")
            .min(2, "Group capacity must be at least 2 attendees"),
      }),
      
    }),
    onSubmit: async (values) => {
      try {
        setIsLoading(true);
        const eventData = localStorage.getItem("eventData");
        if (eventData) {
          const eventSlug = JSON.parse(eventData).slugId;
          const groupTicketCount = showGroupTicketField ? values.groupTicketCount : 0;
          const payload = {
            ...values,
            eventSlug,
            venueId: values.venueId || null,
            isGroupTicket: showGroupTicketField,
            groupTicketCount,
            groupingId: values.groupingId,
            ticketOrder: null,
            maxCount: Number(values.maxCount) || null,
          };
          const response = await createTicket(payload);
          toast.success("Ticket Created successfully");
          toggle();
          await getTicketList();
          validation.resetForm();
          if (groupTicketList.length === 1) {
            validation.setFieldValue("groupingId", groupTicketList[0].id);
            validation.setFieldValue("groupName", groupTicketList[0].name);
          }
        }
      } catch (error) {
        console.error("Error creating ticket:", error);
        toast.error("Error creating ticket");
      }
      finally{
        setIsLoading(false);
      }
    },
  });
  useEffect(() => {
  if (groupTicketList.length === 1) {
    const group = groupTicketList[0];
    if (!validation.values.groupingId) {
      validation.setFieldValue("groupingId", group.id);
      validation.setFieldValue("groupName", group.name);
    }
  }
}, [groupTicketList]);
  const onSelectedVenue = (venueId: any) => {
    setSelectedVenueForAdd(String(venueId));
  };
  const handleGroupSorting = (selectedId: any) => {
    setSelectedGroupSorting(String(selectedId));
  };
  const handleTicketSubmit = async (values: any) => {
  if (!isTicketFreeResolved) {
    toast.error("Still confirming this event's pricing type, please try again in a moment.");
    return;
  }
  setIsLoading(true);
  try {
    const eventData = localStorage.getItem("eventData");
    if (!eventData) return;

    const eventSlug = JSON.parse(eventData).slugId;
    
    const payload = {
      ...values,
      eventSlug,
      venueId: hasMultipleVenues ? values.venueId : null,
      groupingId: hasMultipleTicketGroups ? values.ticketGroupId : groupTicketList[0].id,
      price: isTicketFree ? 0 : values.price,
      maxCount: values.maxCount === 0 || isNaN(values.maxCount) ? null : values.maxCount,
      isGroupTicket: ticketKind === "group",
      groupTicketCount: ticketKind === "group" ? values.groupTicketCount : 0,
      ticketOrder: values.ticketOrder,
      ticketStatus: "active"
    };

    await createTicket(payload); 
    toast.success("Ticket created successfully");

    await getTicketList();
    setIsModalOpen(false); 
  } catch (error) {
    console.error("Error creating ticket:", error);
    toast.error("Error creating ticket");
  } finally {
    setIsLoading(false);
  }
};

    const handleSaveTicketGroup = (ticketGroup: TicketGroupData) => {
        let updatedTicketGroups;
        if (editingTicketGroup) {
          // Update existing ticket group
          updatedTicketGroups = ticketGroups.map(tg => 
            tg.id === ticketGroup.id ? ticketGroup : tg
          );
        } else {
          // Add new ticket group
          updatedTicketGroups = [...ticketGroups, ticketGroup];
        }
        setTicketGroups(updatedTicketGroups);
        setIsTicketGroupModalOpen(false);
      };
    useEffect(() => {
      try {
        const eventData = localStorage.getItem("eventData");
        if (eventData) {
          const hasMultipleVenues = JSON.parse(eventData).hasMultipleVenues;
          if (hasMultipleVenues) {
            setHasMultipleVenues(hasMultipleVenues);
          }
          const hasMultipleTicketGroups = JSON.parse(eventData).hasMultipleTicketGroups;
          if (hasMultipleTicketGroups) {
            setHasMultipleTicketGroups(hasMultipleTicketGroups);
          }
        }
      } catch (err) {
        console.error("Error reading eventData from localStorage:", err);
      }
    }, []);
  return (
    <div className={`contact-list-container ${isNightMode ? 'text-white' : 'text-dark'}`}>
      <Background />
      <PageHeader
        title="Ticket List"
        subtitle="Configure event ticket classes, set prices, capacity limits, group access rules, and monitor real-time ticket sales."
        isLoading={isLoading}
        actions={
          <div className="ticket-list-header-actions d-flex align-items-center gap-2 flex-wrap">
            {hasHiddenTickets && (
              <button
                type="button"
                onClick={handleCopyLink}
                className="contact-action-btn py-2 px-3 fw-semibold fs-12px"
              >
                <i className="fa-solid fa-link me-2"></i> Copy Hidden Ticket Link
              </button>
            )}
            <div className="dropdown dropdown-default dropdown-normal btn-ticket-type-top ticket-list-add-dropdown">
              <button className="dropdown-toggle main-btn btn-hover h_40 pe-4 ps-4 ticket-list-add-btn" type="button">
                <span>Add Tickets</span>
              </button>
              <div className="dropdown-menu dropdown-menu-right">
                <a
                  className="dropdown-item"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    openModal('single');
                  }}
                >
                  <i className="fa-solid fa-ticket me-2"></i>
                  Single Ticket
                </a>
                <a
                  className="dropdown-item"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    openModal('group');
                  }}
                >
                  <i className="fa-solid fa-ticket me-2"></i>
                  Group Ticket
                </a>
              </div>
            </div>
          </div>
        }
      />

      <div className="contact-filter-card mb-4 mt-4 ticket-list-filter">
        <div className="d-flex flex-column flex-md-row align-items-center gap-3 w-100">
          {eventVenuesForAdd.length > 1 && (
            <div style={{ flex: 1, minWidth: "150px" }} className="w-100">
              <CommonSelect
                options={[{ value: "0", label: "All Venues" }, ...eventVenues]}
                value={selectedVenueForAdd}
                onChange={(e) => onSelectedVenue(e.target.value)}
                label="Event Venue"
              />
            </div>
          )}
          {groupTicketList.length > 1 && (
            <div style={{ flex: 1, minWidth: "150px" }} className="w-100">
              <CommonSelect
                options={[{ value: "0", label: "All Group Tickets" }, ...groupTicketList]}
                value={selectedGroupSorting}
                onChange={(e) => handleGroupSorting(e.target.value)}
                label="Group Ticket"
              />
            </div>
          )}
          <div className="position-relative flex-grow-1 w-100">
            <Search className="position-absolute start-0 top-50 translate-middle-y ms-3 contact-sub-text" size={18} />
            <input
              type="text"
              className="contact-search-input"
              placeholder="Search tickets by name..."
              value={search}
              onChange={handleSearch}
            />
          </div>
        </div>
      </div>
      <div>
        <Modal isOpen={modal} toggle={toggle}>
                        <ModalHeader toggle={toggle}>
                          Add New Ticket
                        </ModalHeader>
                        <Form onSubmit={validation.handleSubmit}>
                          <ModalBody className="px-4">
                            <FormGroup>
                              <Label className="form-label">Ticket Name</Label>
                              <Input
                                name="ticketType"
                                type="text"
                                placeholder="Enter Ticket Name"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.ticketType}
                                invalid={
                                  validation.touched.ticketType &&
                                  !!validation.errors.ticketType
                                }
                              />
                              {validation.touched.ticketType &&
                                validation.errors.ticketType ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.ticketType}
                                </FormFeedback>
                              ) : null}
                            </FormGroup>
                            <FormGroup>
                              <Label className="form-label">Ticket Description</Label>
                              <Input
                                name="description"
                                type="text"
                                placeholder="Enter Ticket Description"
                                value={validation.values.description}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                invalid={validation.touched.description && !!validation.errors.description}
                              />
                              {validation.touched.description && validation.errors.description && (
                                <FormFeedback type="invalid">
                                  {validation.errors.description}
                                </FormFeedback>
                              )}
                            </FormGroup>
                            <FormGroup>
                              <Label className="form-label">
                                Ticket Amount
                              </Label>
                              <Input
                                name="price"
                                type="text"
                                placeholder="Enter Ticket Amount"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.price}
                                invalid={
                                  validation.touched.price &&
                                  !!validation.errors.price
                                }
                              />
                              {validation.touched.price &&
                                validation.errors.price ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.price}
                                </FormFeedback>
                              ) : null}
                            </FormGroup>
                            <FormGroup>
                              <Label className="form-label">Max Count</Label>
                              <p className="text-warning">* Enter 0 for unlimited availability.</p>
                              <Input
                                name="maxCount"
                                type="text"
                                placeholder="Enter 0 for unlimited availability."
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.maxCount}
                                invalid={
                                  validation.touched.maxCount &&
                                  !!validation.errors.maxCount
                                }
                              />
                              {validation.touched.maxCount &&
                                validation.errors.maxCount ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.maxCount}
                                </FormFeedback>
                              ) : null}
                            </FormGroup>
                            <FormGroup check>
                              <Label check>
                                <Input
                                  type="checkbox"
                                  checked={showGroupTicketField}
                                  onChange={(e) =>
                                    setShowGroupTicketField(e.target.checked)
                                  }
                                />{" "}
                                <div className="d-flex flex-column">
                                  <p>Group Ticket</p>
                                  <p className="text-warning">* Choose this if you want to create a group ticket<br/>
                                  * Eg: Family , Couple tickets etc..</p>
                                </div>                                
                              </Label>
                            </FormGroup>
                            <br/>
                            {showGroupTicketField && (
                              <FormGroup>
                                <Label>Good For</Label>
                                 <p className="text-warning">* Number of people allowed per ticket</p>
                                <Input
                                  name="groupTicketCount"
                                  type="number"
                                  placeholder="Enter Group Ticket Count"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.groupTicketCount}
                                  invalid={
                                    validation.touched.groupTicketCount &&
                                    !!validation.errors.groupTicketCount
                                  }
                                />
                                {validation.touched.groupTicketCount &&
                                  validation.errors.groupTicketCount ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.groupTicketCount}
                                  </FormFeedback>
                                ) : null}
                              </FormGroup>
                            )}
                            {/* <FormGroup>
                              <Label className="form-label">
                                Ticket Order No
                              </Label>
                              <Input
                                name="ticketOrder"
                                type="text"
                                placeholder="Enter the order no. Eg: 1,2,3"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.ticketOrder}
                                invalid={
                                  validation.touched.ticketOrder &&
                                  !!validation.errors.ticketOrder
                                }
                              />
                              {validation.touched.ticketOrder &&
                                validation.errors.ticketOrder ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.ticketOrder}
                                </FormFeedback>
                              ) : null}
                            </FormGroup> */}
                            { eventVenuesForAdd.length > 1 && (
                              <FormGroup>
                                <Label>Event Venue</Label>
                                <Input
                                  type="select"
                                  name="venueId"
                                  onChange={(e) => {
                                    validation.setFieldValue(
                                      "venueId",
                                      e.target.value
                                    );
                                  }}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.venueId}
                                  invalid={
                                    validation.touched.venueId &&
                                    !!validation.errors.venueId
                                  }
                                >
                                  <option value="">Select Venue</option>
                                  {eventVenuesForAdd.map((venue) => (
                                    <option key={venue.value} value={venue.value}>
                                      {venue.label}
                                    </option>
                                  ))}
                                </Input>
                                {validation.touched.venueId &&
                                  validation.errors.venueId ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.venueId}
                                  </FormFeedback>
                                ) : null}

                              </FormGroup>
                            )}
                            {groupTicketList.length > 1 &&(
                              <>
                                <FormGroup>
                                  <Label>Group Ticket Name</Label>
                                  <Input
                                    type="select"
                                    name="groupingId"
                                    onChange={(e) => {
                                      console.log("e.target.value", e.target.value);
                                      validation.handleChange(e);
                                
                                    }}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.groupingId}
                                    invalid={
                                      validation.touched.groupingId &&
                                      !!validation.errors.groupingId
                                    }
                                  >
                                    <option value="">Select Group</option>
                                    {groupTicketList.map((group: any) => (
                                      <option
                                        key={group.value}
                                        value={group.value}
                                      >
                                        {group.label || "Unnamed Group"}
                                      </option>
                                    ))}
                                  </Input>
                                  {validation.touched.groupingId &&
                                    validation.errors.groupingId ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.groupingId}
                                    </FormFeedback>
                                  ) : null}
                                </FormGroup>
                              </>
                            )}
                          </ModalBody>
                          <ModalFooter>
                            <Button className="btn btn-primary mt-3 w-100 h_50" color="primary" type="submit" disabled={isLoading}>
                               <h5>
                              {isLoading ? "Creating..." : "Create Ticket"}
                            </h5>

                            </Button>{" "}
                          </ModalFooter>
                        </Form>
                      </Modal>
                      <Modal isOpen={editModal} toggle={toggleEditModal}>
                        <ModalHeader toggle={toggleEditModal}>Edit Ticket</ModalHeader>
                        <Form onSubmit={editValidation.handleSubmit}>
                          <ModalBody className="px-4">
                            <FormGroup>
                              <Label className="form-label">Ticket Name</Label>
                              <Input
                                name="ticketType"
                                type="text"
                                value={editValidation.values.ticketType}
                                onChange={editValidation.handleChange}
                                onBlur={editValidation.handleBlur}
                                invalid={editValidation.touched.ticketType && !!editValidation.errors.ticketType}
                              />
                              {editValidation.touched.ticketType && editValidation.errors.ticketType && (
                                <FormFeedback type="invalid">
                                  {editValidation.errors.ticketType}
                                </FormFeedback>
                              )}
                            </FormGroup>
                            {!isTicketFree && (
                              <FormGroup>
                                <Label className="form-label">Ticket Amount</Label>
                                <Input
                                  name="price"
                                  type="text"
                                  value={editValidation.values.price}
                                  onChange={editValidation.handleChange}
                                  onBlur={editValidation.handleBlur}
                                  invalid={editValidation.touched.price && !!editValidation.errors.price}
                                  disabled={Number(editValidation.values.totalTicketsSold) > 0}
                                />
                                {Number(editValidation.values.totalTicketsSold) > 0 && (
                                  <p className="text-warning mt-1 mb-0" style={{ fontSize: '12px' }}>
                                    * Price cannot be changed because tickets have already been sold.
                                  </p>
                                )}
                                {editValidation.touched.price && editValidation.errors.price && (
                                  <FormFeedback type="invalid">
                                    {editValidation.errors.price}
                                  </FormFeedback>
                                )}
                              </FormGroup>
                            )}
                            <FormGroup>
                              <Label className="form-label">Ticket Order</Label>
                              <Input
                                name="ticketOrder"
                                type="text"
                                value={editValidation.values.ticketOrder}
                                onChange={editValidation.handleChange}
                                onBlur={editValidation.handleBlur}
                                invalid={editValidation.touched.ticketOrder && !!editValidation.errors.ticketOrder}
                              />
                              {editValidation.touched.ticketOrder && editValidation.errors.ticketOrder && (
                                <FormFeedback type="invalid">
                                  {editValidation.errors.ticketOrder}
                                </FormFeedback>
                              )}
                            </FormGroup>
                            <FormGroup>
                              <Label className="form-label">Max Count</Label>
                              <div className="text-warning">* Tickets sold-out till now {editValidation.values.totalTicketsSold}</div>
                              <Input
                                name="maxCount"
                                type="text"
                                min={0}
                                value={editValidation.values.maxCount}
                                onChange={editValidation.handleChange}
                                onBlur={editValidation.handleBlur}
                                invalid={editValidation.touched.maxCount && !!editValidation.errors.maxCount}
                                placeholder="Enter 0 for unlimited availability."
                              />
                            {editValidation.touched.maxCount && typeof editValidation.errors.maxCount === "string" && (
                              <FormFeedback type="invalid">
                                {editValidation.errors.maxCount}
                              </FormFeedback>
                            )}

                            </FormGroup>
                            {editValidation.values.isGroupTicket && (
                              <FormGroup>
                                <Label className="form-label">Good For</Label>
                                <p className="text-warning">* Number of people allowed per ticket</p>
                                <Input
                                  name="groupTicketCount"
                                  type="number"
                                  placeholder="Enter Group Ticket Count"
                                  value={editValidation.values.groupTicketCount}
                                  onChange={editValidation.handleChange}
                                  onBlur={editValidation.handleBlur}
                                  invalid={editValidation.touched.groupTicketCount && !!editValidation.errors.groupTicketCount}
                                  disabled={Number(editValidation.values.totalTicketsSold) > 0}
                                />
                                {Number(editValidation.values.totalTicketsSold) > 0 && (
                                  <p className="text-warning mt-1 mb-0" style={{ fontSize: '12px' }}>
                                    * Group capacity cannot be changed because tickets have already been sold.
                                  </p>
                                )}
                                {editValidation.touched.groupTicketCount && editValidation.errors.groupTicketCount && (
                                  <FormFeedback type="invalid">
                                    {editValidation.errors.groupTicketCount}
                                  </FormFeedback>
                                )}
                              </FormGroup>
                            )}
                            <FormGroup>
                              <Label className="form-label">Ticket Description</Label>
                              <Input
                                name="description"
                                type="text"
                                value={editValidation.values.description}
                                onChange={editValidation.handleChange}
                                onBlur={editValidation.handleBlur}
                                invalid={editValidation.touched.description && !!editValidation.errors.description}
                              />
                              {editValidation.touched.description && editValidation.errors.description && (
                                <FormFeedback type="invalid">
                                  {editValidation.errors.description}
                                </FormFeedback>
                              )}
                            </FormGroup>

                            <FormGroup>
                              <Label className="form-label">Status</Label>
                              <Input
                                name="ticketStatus"
                                type="select"
                                value={editValidation.values.ticketStatus}
                                onChange={editValidation.handleChange}
                                onBlur={editValidation.handleBlur}
                                invalid={editValidation.touched.ticketStatus && !!editValidation.errors.ticketStatus}
                              >
                                <option value="active">Active</option>
                                <option value="inactive">Inactive</option>
                                <option value="sold-out">Sold Out</option>
                                <option value="hidden">Hidden</option>
                              </Input>
                              {editValidation.touched.ticketStatus && editValidation.errors.ticketStatus && (
                                <FormFeedback type="invalid">
                                  {editValidation.errors.ticketStatus}
                                </FormFeedback>
                              )}
                            </FormGroup>
                          </ModalBody>
                          <ModalFooter>
                            <Button className="btn btn-primary mt-3 w-100 h_50" color="primary" type="submit" disabled={isLoading || !isTicketFreeResolved} >
                              <h5>
                              {isLoading ? "Saving..." : "Save Changes"}
                            </h5></Button>
                          </ModalFooter>
                        </Form>

                      </Modal>
                    </div>
                    <div>
                      <ToastContainer autoClose={2000} />
                    </div>
                    <div className="mt-4 d-flex flex-column gap-3 ticket-list-stack">
                      {filteredTickets.length > 1 && (
                        <p className="ticket-list-reorder-hint mb-0">
                          Drag the grip on desktop, or use ↑ ↓ on mobile, to change ticket order.
                        </p>
                      )}
                      {filteredTickets.length > 0 ? (
                        filteredTickets.map((filteredTicket: any, index: number) => (
                          <div
                            key={filteredTicket.ticketTypeId || filteredTicket.id || index}
                            className={`ticket-list-row${dragOverIndex === index ? " is-drop-target" : ""}${draggedIndex === index ? " is-dragging" : ""}`}
                            draggable={filteredTickets.length > 1}
                            onDragStart={(e) => handleDashboardDragStart(e, index)}
                            onDragOver={(e) => handleDashboardDragOver(e, index)}
                            onDrop={(e) => handleDashboardDrop(e, index)}
                            onDragEnd={() => { setDraggedIndex(null); setDragOverIndex(null); }}
                          >
                            {filteredTickets.length > 1 && (
                              <div className="ticket-list-reorder-controls">
                                <div
                                  className="ticket-list-drag-handle"
                                  title="Drag to reorder ticket"
                                  aria-label="Drag to reorder"
                                >
                                  <GripVertical size={18} />
                                </div>
                                <div className="ticket-list-move-btns">
                                  <button
                                    type="button"
                                    className="ticket-list-move-btn"
                                    title="Move up"
                                    aria-label="Move ticket up"
                                    disabled={index === 0}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      moveTicket(index, -1);
                                    }}
                                  >
                                    <ChevronUp size={16} />
                                  </button>
                                  <button
                                    type="button"
                                    className="ticket-list-move-btn"
                                    title="Move down"
                                    aria-label="Move ticket down"
                                    disabled={index === filteredTickets.length - 1}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      moveTicket(index, 1);
                                    }}
                                  >
                                    <ChevronDown size={16} />
                                  </button>
                                </div>
                              </div>
                            )}
                            <div className="flex-grow-1 ticket-list-card-wrap">
                              <ListCard
                                key={filteredTicket.ticketTypeId}
                                cardData={{
                                  icon: "fa-solid fa-ticket",
                                  name: filteredTicket.ticketType,
                                  description: filteredTicket.description,
                                  ticket: `Group: ${filteredTicket?.TicketGroup?.groupName || "N/A"}`,
                                  startDate: filteredTicket.createdAt,
                                  status: filteredTicket.ticketStatus,
                                  isActive: filteredTicket.ticketStatus === "active",
                                  totalUsed: filteredTicket.totalTicketsSold,
                                  totalLimit: filteredTicket.maxCount,
                                  optionHead: "Price",
                                  option: filteredTicket.price,
                                  optionHead1: "Is Group Ticket (Count)",
                                  option1: filteredTicket.isGroupTicket ? `Yes (${filteredTicket.groupTicketCount})` : "No",
                                  optionIcon1: "fa-solid fa-users",
                                }}
                                onEdit={() => handleEdit(filteredTicket)}
                                onDelete={() => handleDelete(filteredTicket)}
                              />
                            </div>
                          </div>
                        ))
                      ) : (
                        <p className="text-muted">No tickets available</p>
                      )}
                    </div>
       <NewTicketModal
        isOpen={isModalOpen}
        toggle={toggleModal}
        onSubmit={handleTicketSubmit}
        isLoading={isLoading || !isTicketFreeResolved}
        ticketKind={ticketKind}
        hasMultipleVenues={hasMultipleVenues}
        venues={venues}
        hasMultipleTicketGroups={hasMultipleTicketGroups}
        ticketGroups={ticketGroups}
        isTicketFree={isTicketFree}
      />

      {/* Ticket Group Modal */}
      <TicketGroupModal
        isOpen={isTicketGroupModalOpen}
        toggle={() => setIsTicketGroupModalOpen(false)}
        onSubmit={handleSaveTicketGroup}
        isLoading={isLoading}
        ticketGroup={editingTicketGroup}
      />

      <ConfirmationDialog
        isOpen={deleteConfirm.isOpen}
        toggle={() => setDeleteConfirm({ isOpen: false, ticket: null })}
        onConfirm={confirmDelete}
        title="Delete Ticket"
        message={`Are you sure you want to permanently delete <strong>${deleteConfirm.ticket?.ticketType || 'this ticket'}</strong>? This action cannot be undone.`}
        confirmText="Yes, Delete"
        cancelText="Cancel"
        type="danger"
        icon="fa-solid fa-trash"
      />
    </div>
  );
};

export default Tickets;